'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _WixComponent2 = require('../BaseComponents/WixComponent');

var _WixComponent3 = _interopRequireDefault(_WixComponent2);

var _PopoverMenu = require('./PopoverMenu.scss');

var _PopoverMenu2 = _interopRequireDefault(_PopoverMenu);

var _Tooltip = require('../Tooltip');

var _Tooltip2 = _interopRequireDefault(_Tooltip);

var _Button = require('../Backoffice/Button');

var _Button2 = _interopRequireDefault(_Button);

var _Dots = require('../Icons/dist/components/Dots');

var _Dots2 = _interopRequireDefault(_Dots);

var _PopoverMenuItem = require('../PopoverMenuItem');

var _PopoverMenuItem2 = _interopRequireDefault(_PopoverMenuItem);

var _classnames2 = require('classnames');

var _classnames3 = _interopRequireDefault(_classnames2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var PopoverMenu = function (_WixComponent) {
  _inherits(PopoverMenu, _WixComponent);

  function PopoverMenu() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, PopoverMenu);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = PopoverMenu.__proto__ || Object.getPrototypeOf(PopoverMenu)).call.apply(_ref, [this].concat(args))), _this), _this.placements = {
      top: _PopoverMenu2.default.topPlacement,
      right: _PopoverMenu2.default.rightPlacement,
      bottom: _PopoverMenu2.default.bottomPlacement,
      left: _PopoverMenu2.default.leftPlacement
    }, _this.placementStyle = function (placement) {
      return _this.placements[placement] || _PopoverMenu2.default.topPlacement;
    }, _this.menuItems = function (items) {
      return _react2.default.Children.map(items, function (item, i) {
        if (!item) {
          return null;
        }

        return _react2.default.createElement(_PopoverMenuItem2.default, _extends({}, item.props, {
          size: _this.props.size,
          key: i,
          onClick: function onClick() {
            _this.tooltip.hide();
            item.props.onClick();
          }
        }));
      });
    }, _this.menu = function () {
      var _classnames;

      return _react2.default.createElement(
        'ul',
        {
          className: (0, _classnames3.default)(_PopoverMenu2.default.menu, (_classnames = {}, _defineProperty(_classnames, _PopoverMenu2.default.large, _this.props.size === 'large'), _defineProperty(_classnames, _PopoverMenu2.default.placementTop, _this.props.placement === 'top'), _defineProperty(_classnames, _PopoverMenu2.default.placementBottom, _this.props.placement === 'bottom'), _classnames))
        },
        _this.menuItems(_this.props.children)
      );
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(PopoverMenu, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          placement = _props.placement,
          size = _props.size,
          maxWidth = _props.maxWidth,
          buttonHeight = _props.buttonHeight,
          buttonTheme = _props.buttonTheme;


      return _react2.default.createElement(
        _Tooltip2.default,
        {
          ref: function ref(tooltip) {
            return _this2.tooltip = tooltip;
          },
          placement: placement,
          alignment: 'center',
          content: this.menu(),
          showTrigger: 'click',
          hideTrigger: 'click',
          showDelay: 0,
          hideDelay: 0,
          theme: 'light',
          size: size,
          padding: 0,
          maxWidth: maxWidth,
          shouldCloseOnClickOutside: true,
          appendTo: this.props.appendTo,
          appendToParent: this.props.appendToParent,
          zIndex: this.props.zIndex
        },
        _react2.default.createElement(
          _Button2.default,
          {
            type: 'button',
            height: buttonHeight,
            theme: buttonTheme
          },
          _react2.default.createElement(_Dots2.default, { size: '12px' })
        )
      );
    }
  }]);

  return PopoverMenu;
}(_WixComponent3.default);

PopoverMenu.propTypes = {
  size: _Tooltip2.default.propTypes.size,
  placement: _Tooltip2.default.propTypes.placement,
  buttonTheme: _Button2.default.propTypes.theme,
  buttonHeight: _Button2.default.propTypes.height,
  maxWidth: _Tooltip2.default.propTypes.maxWidth,
  appendToParent: _Tooltip2.default.propTypes.appendToParent,
  appendTo: _Tooltip2.default.propTypes.appendTo,
  zIndex: _Tooltip2.default.propTypes.zIndex
};
PopoverMenu.defaultProps = {
  size: 'normal',
  placement: 'top',
  buttonTheme: 'icon-greybackground',
  buttonHeight: 'medium',
  maxWidth: '378px'
};
exports.default = PopoverMenu;